<section
  class="topographic-drift"
  [class.is-fallback]="reducedMotion"
  [style.height]="height"
  [style.--scene-intensity-input]="intensity"
  [style.--scene-speed-input]="speed"
>
  <div class="topographic-field">
    <span
      *ngFor="let band of bands; let index = index"
      class="contour-band"
      [style.top]="band.top"
      [style.width]="band.width"
      [style.opacity]="band.opacity"
      [style.animation-delay]="band.delay"
      [style.animation-duration]="band.duration"
      [style.--band-index]="index"
    ></span>
  </div>

  <div class="topographic-focus"></div>
</section>
